"use client";

import React, { CSSProperties } from "react";

export function StateInspectorRow({
  children,
  colorScheme,
  selected,
  style,
  variant,
  bordered = true,
}: {
  children: React.ReactNode;
  colorScheme: "light" | "dark";
  selected?: boolean;
  style?: CSSProperties;
  variant?: "up" | "down";
  bordered?: boolean;
}) {
  const solidBorderColor =
    colorScheme === "light" ? "rgb(223 223 223)" : "rgb(29 29 29)";

  return (
    <div
      style={{
        borderBottom: bordered ? `1px solid ${solidBorderColor}` : undefined,
        fontSize: "12px",
        fontFamily: "Menlo, monospace",
        padding: "2px 12px 1px",
        display: "flex",
        alignItems: "center",
        background:
          variant === "up"
            ? "rgba(0,255,0,0.1)"
            : variant === "down"
              ? "transparent"
              : selected
                ? "rgb(59 130 246 / 15%)"
                : undefined,
        // background:
        //   colorScheme === "light"
        //     ? "rgba(0,0,0,0.05)"
        //     : "rgba(255,255,255,0.05)",
        ...style,
      }}
    >
      <span
        style={{
          fontFamily: "Menlo, monospace",
          fontSize: "11px",
          borderRadius: 4,
          display: "inline-block",
        }}
      >
        {children}
      </span>
    </div>
  );
}
